import { render, staticRenderFns } from "./biz-relation-info-input.vue?vue&type=template&id=3250b068&scoped=true&"
import script from "./biz-relation-info-input.vue?vue&type=script&lang=js&"
export * from "./biz-relation-info-input.vue?vue&type=script&lang=js&"
import style0 from "./biz-relation-info-input.vue?vue&type=style&index=0&id=3250b068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3250b068",
  null
  
)

export default component.exports